var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetaFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 24,
    viewBox: "0 0 70 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BETA",
    transform: "translate(-896 -248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    width: 70,
    height: 24,
    rx: 12,
    transform: "translate(896 248)",
    fill: "#8173e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BETA-2",
    "data-name": "BETA",
    transform: "translate(917 264)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Silka-Regular, Silka"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BETA")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaFeatureIcon);
export default __webpack_public_path__ + "static/media/beta-feature-icon.105653043523b4cba17227fe453d22f6.svg";
export { ForwardRef as ReactComponent };